import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const AgendasSkeleton = () => {
	const { t: tg } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<LayoutGap gap="xl">
				{generateArrayFromLength(10).map((i) => (
					<div key={i}>
						<GovSkeleton
							width={generateRandomNumber(20, 70) + '%'}
							height="30px"
							aria-label={tg('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
							className="mb-2 skeleton-brighter"
						/>
						<div className="flex justify-between items-center px-2 py-3 bg-(--background-neutral-white)">
							<div className="w-full">
								<GovSkeleton
									width={generateRandomNumber(70, 90) + '%'}
									height="24px"
									aria-label={tg('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
									className="[ md:hidden ]"
								/>
								<GovSkeleton
									width={generateRandomNumber(20, 80) + '%'}
									height="24px"
									aria-label={tg('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
							<GovSkeleton
								height="24px"
								width="24px"
								shape="circle"
								aria-label={tg('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</div>
					</div>
				))}
			</LayoutGap>
		</ContentLayout>
	);
};
